import { useTranslation } from 'react-i18next';
import { type OptionalAssets } from '@monorepo/types';
import { type CreditCartAsset, CreditEventType } from '../credit-events.types';
import CreditEventsContentLayout from './credit-events-content-layout';

interface ReceivedCreditContentProps {
  type: CreditEventType;
  creditAmount: number;
  onRedeem: () => void;
  onSeeAllCredits: () => void;
  cartAssets?: CreditCartAsset[];
  onRedeemForAsset?: (asset: OptionalAssets) => void;
  onNewOrder?: () => void;
}

const ReceivedCreditContent = ({
  type,
  creditAmount,
  onRedeem,
  onSeeAllCredits,
  cartAssets,
  onRedeemForAsset,
  onNewOrder,
}: ReceivedCreditContentProps) => {
  const { t } = useTranslation(['creditEventsModal']);

  return (
    <CreditEventsContentLayout
      type={type}
      title={t('creditEventsModal:received_credit.title')}
      emphasis={t('creditEventsModal:received_credit.amount', {
        amount: creditAmount,
      })}
      body={t('creditEventsModal:received_credit.text')}
      redeemLabel={t('creditEventsModal:redeem_credits_button')}
      seeAllLabel={t('creditEventsModal:show_all_credits_button')}
      onRedeem={onRedeem}
      onSeeAllCredits={onSeeAllCredits}
      cartAssets={cartAssets}
      onRedeemForAsset={onRedeemForAsset}
      onNewOrder={onNewOrder}
    />
  );
};

export default ReceivedCreditContent;
